import { useTranslation } from 'react-i18next';
import { useStandingOrderOptions, useStandingOrdersListQuery } from '../../../api/standing-orders';
import { MainLayout } from '../../Layout/MainLayout';
import { ButtonLink, TableContentIsland } from '@razz-team/ui-web';
import { useHasRole } from '../../../api/access';
import { StandingOrdersTable } from './StandingOrdersTable';
import { useMemo } from 'react';

export function StandingOrdersPage() {
  const { t } = useTranslation();
  const query = useStandingOrdersListQuery();
  const isPayer = useHasRole('PAYER');

  // preload options
  useStandingOrderOptions();

  const filtered = useMemo(
    () => query.data?.filter((order) => order.status !== 'TERMINATED'),
    [query.data],
  );

  return (
    <MainLayout
      title={t('Standing orders')}
      subtitle={t('Automatically distribute incoming payments')}
      actions={
        isPayer ? (
          <ButtonLink to="/account/standing-orders/create">{t('Add standing order')}</ButtonLink>
        ) : null
      }
    >
      <TableContentIsland>
        <StandingOrdersTable orders={filtered} isLoading={query.isPending} error={query.error} />
      </TableContentIsland>
    </MainLayout>
  );
}
